/**
 * Should a thread-level inbound frame sound / notify? `signature` is the message's own timestamp
 * (or its preview text when the frame carries no timestamp); `held` is the last one alerted for
 * that thread. Same signature = repeat (typing -> message, read, reconnect replay); an OLDER
 * timestamp = a replayed frame, also silent. Only a genuinely later message alerts.
 */
export function isNewAlertSignature(held: string | undefined, signature: string): boolean {
  if (held === signature) return false;
  const a = Date.parse(signature);
  const b = held === undefined ? Number.NaN : Date.parse(held);
  if (!Number.isNaN(a) && !Number.isNaN(b)) return a > b;
  return true;
}
